<template>
  <div id="job-act-histories-content">
    <!-- 로딩 상태 -->
    <div v-if="loading" class="loading-container text-center mt-40">
      <div class="spinner-border" role="status">
        <span class="sr-only">로딩 중...</span>
      </div>
      <p class="mt-2">사업참여 이력을 불러오는 중입니다...</p>
    </div>

    <!-- 에러 상태 -->
    <div v-else-if="error" class="error-container mt-40">
      <div class="alert alert-danger" role="alert">
        <h4 class="alert-heading">데이터 로딩 실패</h4>
        <p>{{ error }}</p>
        <hr>
        <button class="btn btn-outline-danger" @click="retryLoad">다시 시도</button>
      </div>
    </div>

    <!-- 데이터 표시 -->
    <div v-else>
            <div class="box-type bg-primary block text-l mt-40">
                ※서울시 50플러스 재단에서 진행한 사업에 참여한 이력입니다.<br>참여한 이력이 보이지 않을 경우 대표전화 (02-460-5050)으로 문의하여주시기 바랍니다.
            </div>
            <h3 class="section-title mt-40">사업 참여이력</h3>

            <!-- 빈 데이터 상태 -->
            <div v-if="jobActHistories.length === 0" class="empty-state mt-40 text-center">
              <div class="empty-icon mb-3">
                <i class="fas fa-briefcase fa-3x text-muted"></i>
              </div>
              <p class="text-muted">아직 참여한 사업이 없습니다.<br>50플러스 재단의 다양한 사업에 참여해보세요.</p>
            </div>

            <!-- 데이터 목록 -->
            <div v-else class="table-wrap" v-for="(jobActHistory, index) in jobActHistories" :key="index">
                <table class="table-body-only">
                    <caption>사업 참여이력 정보 테이블{{ count(index) }}</caption>
                    <colgroup class="pc-cell">
                        <col style="width: 160px;" />
                        <col />
                    </colgroup>
                    <colgroup class="mo-cell">
                        <col style="width: 88px;" />
                        <col />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th scope="row" colspan="2">
                                <div class="history-item">
                                    <div class="history-item-num">{{ count(index) }}</div>
                                    <div class="history-item-subject">
                                        {{ jobActHistory.bizCateName }} ({{ jobActHistory.bizYear }})
                                    </div>
                                </div>
                            </th>
                        </tr>
                        <tr>
                            <th scope="row" class="no-bg">세부<br class="mo-only">사업명</th>
                            <td>{{ jobActHistory.detailBizName }}</td>
                        </tr>
                        <tr>
                            <th scope="row" class="no-bg">공고명</th>
                            <td>{{ jobActHistory.annName }}</td>
                        </tr>
                        <tr>
                            <th scope="row" class="no-bg">활동기간</th>
                            <td>{{ jobActHistory.actStartDate }} ~ {{ jobActHistory.actEndDate }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'job-act-histories-template',
  props: {
    jobActHistoriesModal: {
      type: Boolean,
      default: false,
    },
    indbankNo: {
      type: String,
      default: '',
    },
    autoLoad: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      jobActHistories: [],
      loading: false,
      error: null,
    };
  },
  watch: {
    jobActHistoriesModal(newVal) {
      // 모달이 열릴 때만 데이터 로드 (API 호출 최적화)
      if (newVal && this.autoLoad && this.jobActHistories.length === 0) {
        this.getJobActHistories();
      }
    },
  },
  methods: {
    async getJobActHistories() {
      this.loading = true;
      this.error = null;

      try {
        const response = await Axios.get('/api/idb/job-act-history');

        if (response.data.success === 'R') {
          this.jobActHistories = response.data.data || [];
        } else {
          throw new Error('데이터를 불러오는데 실패했습니다.');
        }
      } catch (error) {
        console.error('[JobActHistories] API Error:', error);
        this.error = (error.response && error.response.data && error.response.data.message) || '사업참여 이력을 불러오는 중 오류가 발생했습니다.';

        // 에러 로그 전송 (선택적)
        this.$emit('error', {
          component: 'JobActHistories',
          error: error.message,
          timestamp: new Date().toISOString(),
        });
      } finally {
        this.loading = false;
      }
    },

    retryLoad() {
      this.getJobActHistories();
    },
    count(num) {
      return String(num + 1).padStart(2, '0');
    },
  },
  computed: {
  },
  mounted() {
    // API 호출 최적화: autoLoad가 true이고 모달이 활성화된 상태에서만 로드
    if (this.autoLoad && this.jobActHistoriesModal) {
      this.getJobActHistories();
    }
  },
};
</script>


// WEBPACK FOOTER //
// JobActHistories.vue?f74773c6